import scrollToEl from "common/action-function/scrollToElement";

export default function TableOfContents({ data }) {
  const renderToc = (list, padding, classChild) => {
    return (
      <ul id="toc-list-table" className={padding || "pl-0"}>
        {list.map((item, index) => (
          <li key={index} className="">
            <a
              href={item.hash}
              className={`block w-fit ${
                classChild || item.children?.length > 0 ? "mb-2" : "mb-4"
              } hover:text-bbc-brand-600`}
              onClick={(e) => {
                scrollToEl(e, true);
              }}
            >
              {item.text
                .replace(/&amp;/g, "&")
                .replace(/&#8211;/g, "-")
                .replace(/&#8217;/g, "'")
                .replace(/&#8220;/g, "“")
                .replace(/&#8221;/g, "”")}
            </a>
            {item.children?.length > 0 &&
              renderToc(item.children, "pl-6 mb-4", "mb-2")}
          </li>
        ))}
      </ul>
    );
  };

  return <div className="">{renderToc(data)}</div>;
}
